import moment from 'moment';
import {
  getRoomAbnormalReportDownLoad,
  getRoomStatisticsReport
} from '../services/report';
import { getZoneTreeData } from '../services/calender';

export default {
  namespace: 'roomAbnormallyReport',
  state: {
    startTime: moment()
      .startOf('day')
      .valueOf(),
    endTime: moment()
      .endOf('day')
      .valueOf(),
    meetingName: '',
    pageNo: 1,
    pageSize: 10,
    searchData: [],
    meetingTreeData: { child: [] },
    meetingSearchInfo: {
      meetingType: undefined,
      meetingDevice: undefined,
      moreMeeting: []
    }
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    },
    setMeetingTreeData(state, { meetingTreeData }) {
      return { ...state, meetingTreeData };
    }
  },
  effects: {
    *search(undefined, { call, select, put }) {
      const { token } = yield select(state => state.login);
      let startTime = yield select(
        state => state.roomAbnormallyReport.startTime
      );
      let endTime = yield select(state => state.roomAbnormallyReport.endTime);
      let meetingName = yield select(
        state => state.roomAbnormallyReport.meetingName
      );
      let meetingSearchInfo = yield select(
        state => state.roomAbnormallyReport.meetingSearchInfo
      );
      let pageNo = yield select(state => state.roomAbnormallyReport.pageNo);
      let pageSize = yield select(state => state.roomAbnormallyReport.pageSize);
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      // let data = yield call(getRoomReport, {
      //   startDate: startTime.startOf('day').valueOf(),
      //   endDate: endTime.endOf('day').valueOf(),
      //   meetingName,
      //   roomIds,
      //   locale,
      //   pageNo,
      //   pageSize,
      //   token
      // })
      let data = yield call(getRoomStatisticsReport, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        roomNames: meetingName,
        roomIds,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *downloadRoom({}, { select, call }) {
      const { token } = yield select(state => state.login);
      let startTime = yield select(
        state => state.roomAbnormallyReport.startTime
      );
      let endTime = yield select(state => state.roomAbnormallyReport.endTime);
      let meetingName = yield select(
        state => state.roomAbnormallyReport.meetingName
      );
      let meetingSearchInfo = yield select(
        state => state.roomAbnormallyReport.meetingSearchInfo
      );
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      yield call(getRoomAbnormalReportDownLoad, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        roomNames: meetingName,
        roomIds,
        locale,
        token
      });
    },
    *changePage({ payload }, { call, select, put }) {
      yield put({ type: 'setState', payload: { ...payload } });
      const { token } = yield select(state => state.login);
      let startTime = yield select(
        state => state.roomAbnormallyReport.startTime
      );
      let endTime = yield select(state => state.roomAbnormallyReport.endTime);
      let meetingName = yield select(
        state => state.roomAbnormallyReport.meetingName
      );
      let meetingSearchInfo = yield select(
        state => state.roomAbnormallyReport.meetingSearchInfo
      );
      let pageNo = yield select(state => state.roomAbnormallyReport.pageNo);
      let pageSize = yield select(state => state.roomAbnormallyReport.pageSize);
      let id = meetingSearchInfo.moreMeeting;
      let roomIds = (id && id.length > 0 && id.join(';')) || '';
      const { locale } = yield select(state => state.i18n);
      let data = yield call(getRoomStatisticsReport, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        roomNames: meetingName,
        roomIds,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *getMeetingTreeDataForSearch({}, { select, put, call }) {
      const { locale } = yield select(state => state.i18n);
      const data = yield call(getZoneTreeData, {
        pageNo: '',
        pageSize: '',
        startTime: moment()
          .startOf('day')
          .valueOf(),
        endTime: '',
        flag: 3,
        otherRoomIds: '',
        audit: '',
        name: '',
        deviceIds: '',
        teaIds: '',
        lang: locale
      });
      yield put({ type: 'setMeetingTreeData', meetingTreeData: data.data });
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname, query }) => {
        if (pathname.indexOf('roomAbnormallyReport') > -1) {
          dispatch({ type: 'getMeetingTreeDataForSearch' });
          const fromDetail = query.detail;
          if (!fromDetail) {
            let p = {
              startTime: moment().subtract(1, 'days'),
              endTime: moment().subtract(1, 'days'),
              meetingName: '',
              pageNo: 1,
              pageSize: 10,
              searchData: [],
              meetingTreeData: { child: [] },
              meetingSearchInfo: {
                meetingType: undefined,
                meetingDevice: undefined,
                moreMeeting: []
              }
            };
            dispatch({ type: 'setState', payload: p });
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/roomReportAbnormally.js